<template>
  <el-drawer
    ref="drawer"
    :title="$t('CargoMsg.Cargo_LoadingPool')"
    :visible="innerVisible"
    size="50%"
    custom-class="setting-and-tools-drawer"
    :modal="false"
    append-to-body
    @close="handleClose"
  >
    <load-pool v-if="innerVisible" style="height: 100%" :airline-product-down-list="airlineProductDownList" :source="SystemConstants.LOAD_POOL_SOURCE_DETAIL.code" @addUldItemsToUld="addUldItemsToUld" />
  </el-drawer>
</template>

<script>
import loadPool from '@/views/cargo/v0/AirExport/components/loadManagement/loadPool'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'LoadPoolDrawer',
  components: { loadPool },
  props: {
    airlineProductDownList: { type: Array, default: () => [] },
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      SystemConstants,
      innerVisible: false
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    addUldItemsToUld(selectedRows) {
      const errorRow = selectedRows.find(p => !p.quantityNotAssembly || !p.weightNotAssembly || !p.cubageNotAssembly || !p.chargeWeightNotAssembly ||
        p.quantityNotAssembly <= 0 || p.weightNotAssembly <= 0 || p.cubageNotAssembly <= 0 || p.chargeWeightNotAssembly <= 0)
      if (errorRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FieldsCannotBeEmpty'))
        return
      }
      this.$emit('addUldItemsToUld', selectedRows)
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
